import {Component, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';
import {ProyectoTramiteItem} from "../../../../interfaces/proyecto.interface";
import {TramiteStatsInterface} from "../../../../../shared/interfaces/tramites-estadisticas";
import {TramiteService} from "../../../../tramites/services/tramite.service";
import {EvalInterface, EvaluacionEstado} from "../../../../../officials/evaluaciones/interfaces/evaluaciones.interface";

@Component({
    selector: 'app-tramites-por-proyecto',
    templateUrl: './tramites-por-proyecto.component.html',
    styleUrls: ['./tramites-por-proyecto.component.css']
})
export class TramitesPorProyectoComponent implements OnInit {
    @Input() datosCargados!: boolean;
    @Input() loading!: TemplateRef<any>;
    @Input() tramitesPorProyecto: ProyectoTramiteItem[] = [];
    @Input() btnTramites!: TemplateRef<any>;
    @Output() itemClickedBtnTramites = new EventEmitter<{ tramite: any, event: Event }>();
    informacionTramiteClicked!: TramiteStatsInterface;
    datos:boolean = false;
    openDialog: boolean = false;
    constructor(protected tramite: TramiteService) {
    }
    ngOnInit(): void {
        console.log("onInit tramites-por-proyecto...");
    }
    /**
     * Muestra la informacion en el componente hijo que posee el tag (requisitos-informacion-componente)
     * */
    mostrarEstadisticas(tramite: any): TramiteStatsInterface {
        return {
            idTramite: tramite?.idTramite,
            idProyecto: tramite?.idProyecto,
            idSolicitud: tramite?.idSolicitud,
            nombreTramite: tramite?.nombreTramite,
            stats:{ qtycumplidos: tramite.qtycumplidos, qtyrequeridos: tramite.qtyrequeridos },
            requisitos: []
        };
    }
    /**
     * Abre el componente hijo que posee el dialog (info-dialog-componente) y obtiene la
     * informacion del tramite cuando se da clic
     * */
    showDialog(info:any) {
        this.openDialog = true;
        this.informacionTramiteClicked=info
        this.datos=false;
    }

    closeDialog() {
        this.openDialog = false;
    }
    onItemClickedTramite(tramite: ProyectoTramiteItem, event: Event) {
        this.itemClickedBtnTramites.emit({tramite, event});
    }

}
